<template>
  <div class="recharge-record-list">
    <div class="content">
      <van-empty v-if="orderList.length == 0" :description="$t('no data')" />
      <div class="list-box" v-if="orderList.length > 0">
        <div class="list-box-item" v-for="item in orderList" :key="item.id">
          <div class="list-box-item-top">
            <img src="../../assets/USDT.png" alt="" /> {{ item.type
            }}{{ $t("recharge") }}
          </div>
          <div class="list-box-item-bot">
            <div class="list-box-item-bot-col">
              <div class="col-top">{{ $t("amount") }}</div>
              <div class="col-bot price">+{{ item.money }}</div>
            </div>
            <div class="list-box-item-bot-col">
              <div class="col-top">{{ $t("state") }}</div>
              <div class="col-bot" v-if="item.status == 1">
                {{ $t("processing") }}
              </div>
              <div class="col-bot" v-if="item.status == 2">
                {{ $t("credited") }}
              </div>
              <div class="col-bot" v-if="item.status == 3">
                {{ $t("fail") }}
              </div>
            </div>
            <div class="list-box-item-bot-col time">
              <div class="col-top">{{ $t("time") }}</div>
              <div class="col-bot time">
                {{
                  (item.created_at * 1000) | dateFormat("MM/dd/yyyy hh:mm:ss")
                }}
              </div>
            </div>
          </div>
          <div class="list-box-item-remark" v-if="item.message">
            {{ $t("record_tip") }}: {{ item.message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderList: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-record-list {
  background: #fff;
  margin-top: 10px;
  padding-top: 10px;
  .content {
    margin-top: 5px;
    min-height: calc(100vh - 100px);
    .list-box {
      &-item {
        padding: 10px 15px 15px;
        border-bottom: 1px solid #eee;
        &-top {
          display: flex;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-right: 3px;
          }
        }
        &-bot {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          &-col {
            display: flex;
            flex-direction: column;
            .col-top {
              color: #7d919d;
              font-size: 12px;
            }
            .col-bot {
              margin-top: 10px;
              font-size: 14px;
            }

            .price {
              color: #00b08c;
              font-weight: bold;
              font-size: 16px;
            }
            .time {
              font-weight: bold;
            }
          }
          .time {
            align-items: flex-end;
          }
        }
        &-remark {
          padding-top: 10px;
          font-size: 12px;
          color: #7d919d;
        }
      }
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    height: 100px;
    left: unset;
  }
  /deep/ .van-popup--bottom {
    width: 540px;
    left: unset;
  }
  .recharge-record-list {
    background: #fff;
    margin-top: 10px;
    padding-top: 10px;
    .content {
      margin-top: 5px;
      min-height: calc(100vh - 100px);
      .list-box {
        &-item {
          padding: 10px 15px 15px;
          border-bottom: 1px solid #eee;
          &-top {
            display: flex;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
              margin-right: 3px;
            }
          }
          &-bot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            &-col {
              display: flex;
              flex-direction: column;
              .col-top {
                color: #7d919d;
                font-size: 12px;
              }
              .col-bot {
                margin-top: 10px;
                font-size: 14px;
              }

              .price {
                color: #00b08c;
                font-weight: bold;
                font-size: 16px;
              }
              .time {
                font-weight: bold;
              }
            }
            .time {
              align-items: flex-end;
            }
          }
          &-remark {
            font-size: 12px;
            color: #7d919d;
            padding-top: 10px;
          }
        }
      }
    }
  }
}
</style>